import { Alert, Container, Stack } from "@mui/material";
import QRCode from "qrcode";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../../components/exports";

export default function CourseQRCode() {
    let { id } = useParams();

    const [error, setError] = useState(false);

    useEffect(() => {
        var canvas = document.getElementById("canvas");

        QRCode.toCanvas(
            canvas,
            `${process.env.REACT_APP_MANAGEMENT_URL}/course/qr-code/${id}`,
            { scale: 10 },
            (error) => {
                if (error) {
                    setError(true);
                }
            }
        );
    }, []);

    return (
        <Container maxWidth="sm">
            <PageHeader title="کد ورود به جلسه" />

            {error && <Alert severity="error">خطا در ایجاد QR Code</Alert>}

            <Stack alignItems="center" spacing={2}>
                <canvas width={500} height={500} id={"canvas"} />

                <Alert severity="warning">
                    این کد فقط برای اسکن توسط پرسنل پرشین سازه طراحی شده، لذا از
                    اسکن کردن آن خودداری نمایید.
                </Alert>
            </Stack>
        </Container>
    );
}
